import { useLocalStorage } from "@vueuse/core"
import { defineStore } from "pinia"

const chartWidgetId = useLocalStorage<string | null>("playground-chartWidgetId", null)
const formula = useLocalStorage<string | null>("playground-formula", null)

interface State {
  dialog: boolean
  chartWidgetId: string | null
  formula: string | null
}

export const usePlaygroundStore = defineStore("playground", {
  state: (): State => ({
    dialog: false,
    chartWidgetId: null,
    formula: null
  }),
  actions: {
    resetState() {
      this.chartWidgetId = null
      this.formula = null
    },
    resetLocalStorage() {
      chartWidgetId.value = null
      formula.value = null
    },
    saveState() {
      chartWidgetId.value = this.chartWidgetId
      formula.value = this.formula
    },
    loadState() {
      this.chartWidgetId = chartWidgetId.value
      this.formula = formula.value
    }
  },
})
